import type { ENVIRONMENT } from '../types/environment';

export const ENVIRONMENTS: Record<string, ENVIRONMENT> = {
  DEVELOPMENT: 'development',
  BETA: 'beta',
  STAGING: 'staging',
  PRODUCTION: 'production',
};
